let bundleOffers = {};

function addToCart(variantIds) {
  variantIds.forEach(variantId => {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
    .then(response => response.json())
    .then(data => {
      console.log("Added to cart:", data);
    })
    .catch(error => {
      console.error("Error adding to cart:", error);
    });
  });

  // Optionally refresh or update the cart UI
}

function getSelectedItems(container) {
  let pickers = Array.from(container.querySelector('.bundle-offer-radio:checked').labels[0].querySelectorAll('.bundle-offer__variant-picker'));
  let items = pickers.map((picker) => {
    return {
      id: picker.querySelector('[data-variant-bundle-id]').value, // Variant ID of the first product
      quantity: 1
    }
  });
  return items;
}

function addBundleToCart(e) {
    let container = e.currentTarget.closest('.bundle-offers-container');
    let items = getSelectedItems(container); 

    // Function to add items to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json' // Ensure the response is in JSON
      },
      body: JSON.stringify({ items: items })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Products added to cart:', data);
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        // window.location.href = theme.routes.cart;
      }, 100);
      // Optionally, update the cart UI or notify the user
    })
    .catch((error) => {
      console.error('Error adding products to cart:', error);
      // Handle errors here
    });
}

document.addEventListener('DOMContentLoaded', function() {
  bundleOffers.addToCartButton = document.querySelector('.bundle-offer-cart-cta');
  // bundleOffers.addToCartButton.addEventListener('click', function() {
  //   let items = getSelectedItems(); 
  //   debugger

  //   // Function to add items to cart
  //   fetch('/cart/add.js', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Accept': 'application/json' // Ensure the response is in JSON
  //     },
  //     body: JSON.stringify({ items: items })
  //   })
  //   .then(response => response.json())
  //   .then(data => {
  //     console.log('Products added to cart:', data);
  //     setTimeout(() => {
  //       document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
  //         bubbles: true
  //       }));
  //       document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
  //       // window.location.href = theme.routes.cart;
  //     }, 100);
  //     // Optionally, update the cart UI or notify the user
  //   })
  //   .catch((error) => {
  //     console.error('Error adding products to cart:', error);
  //     // Handle errors here
  //   });
  // });
});
